import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Wrapper } from '../../components'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Toolbar from '@material-ui/core/Toolbar'
import Paper from '@material-ui/core/Paper'
import Tooltip from '@material-ui/core/Tooltip'
import PersonIcon from '@material-ui/icons/Person'
//import IconButton from '@material-ui/core/IconButton';
//import DeleteIcon from '@material-ui/icons/Delete';
//import FilterListIcon from '@material-ui/icons/FilterList';
import Typography from '@material-ui/core/Typography'
import { lighten } from '@material-ui/core/styles/colorManipulator'

//import EnquiryDialog from './EnquiryDialog';

import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { statusColors } from '../../utils/colors'
import * as API from '../../utils/api'

const columnData = [
  { id: 'name', numeric: false, disablePadding: false, label: 'Company' },
  { id: 'location', numeric: false, disablePadding: false, label: 'Location' },
  { id: 'space', numeric: false, disablePadding: false, label: 'Size' },
  { id: 'commencementDate', numeric: true, disablePadding: false, label: 'Commencement date' },
  { id: 'receivedOn', numeric: true, disablePadding: false, label: 'Received' },
  { id: 'status', numeric: true, disablePadding: false, label: 'Status' },
];

class EnquiriesTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title="Sort"
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnquiriesTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

let EnquiriesTableToolbar = props => {
  const { classes } = props;

  return (
    <Toolbar
      className={classNames(classes.root)}
    >
      <div className={classes.title}>
        <Typography variant="title" id="tableTitle">
          Enquiries
        </Typography>
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {/*<Tooltip title="Filter list">
          <IconButton aria-label="Filter list">
            <FilterListIcon />
          </IconButton>
        </Tooltip>*/}
      </div>
    </Toolbar>
  );
};

EnquiriesTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired
};

EnquiriesTableToolbar = withStyles(toolbarStyles)(EnquiriesTableToolbar);

const styles = theme => ({
  root: {
    width: '100%'
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  rowHeader: {
    fontWeight: '500',
    maxWidth: '250px'
    //cursor: 'pointer'
  }
});

class EnquiriesTable extends React.Component {
  constructor(props) {
    super(props);

    const { enquiries } = this.props;
    const enquiriesData = Object.values(enquiries)

    this.state = {
      order: 'desc',
      orderBy: 'receivedOn',
      data: enquiriesData.sort((a, b) => b.receivedOn.localeCompare(a.receivedOn)),
      page: 0,
      rowsPerPage: 10,
      open: false,
      enquiry: {}
    };
  }

  handleRequestSort = (event, property) => {
    const orderBy = property
    let order = 'desc'

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc'
    }

    const data =
      order === 'desc'
        ? this.state.data.sort((a, b) => b[orderBy].localeCompare(a[orderBy]))
        : this.state.data.sort((a, b) => a[orderBy].localeCompare(b[orderBy]));

    this.setState({ data, order, orderBy });
  };

  handleClick = (event, id) => {
    API.getEnquiry(id)
      .then((enquiry) => {
        this.setState(() => ({
          open: true,
          enquiry
        }))
      })
  }

  handleClose = () => {
    this.setState({ open: false, enquiry: {} });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  render() {
    const { classes } = this.props
    const { data, order, orderBy, rowsPerPage, page, open, enquiry } = this.state
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage)
    const statusColor = [statusColors.new, statusColors.confirmed, statusColors.rejected, statusColors.finalised, statusColors.canceled]
    const statusArray = ['New', 'Confirmed', 'Rejected', 'Finalised', 'Canceled']

    return (
    	<Wrapper>
        <Paper className={classes.root}>
          <EnquiriesTableToolbar />
          <div className={classes.tableWrapper}>
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnquiriesTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
              />
              <TableBody>
                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(enquiry => {
                  const color = statusColor[enquiry.statusId - 1]

                  return (
                    <TableRow
                      hover
                      //onClick={event => this.handleClick(event, enquiry.id)}
                      tabIndex={-1}
                      key={enquiry.id}
                    >
                      <TableCell component="th" scope="row" className={classes.rowHeader} style={{ borderLeft: `3px solid ${color}` }}>
                        <Link to={`/enquiry/${enquiry.id}`}>
                          {enquiry.name}
                        </Link>
                      </TableCell>
                      <TableCell style={{ whiteSpace: 'pre-wrap' }}>{enquiry.location}</TableCell>
                      <TableCell numeric>
                        {enquiry.numberOfEmployees
                          ? <Fragment>
                              <span style={{ verticalAlign: 'middle' }}>{enquiry.numberOfEmployees}</span>
                              <PersonIcon style={{ fontSize: 13, verticalAlign: 'middle' }} />
                            </Fragment>
                          : enquiry.space ? enquiry.space : 'n/a'
                        }
                      </TableCell>
                      <TableCell numeric>{enquiry.commencementDate}</TableCell>
                      <TableCell numeric>{enquiry.receivedOn}</TableCell>
                      <TableCell numeric style={{ color: color }}>{statusArray[enquiry.statusId-1]}</TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
          />
        </Paper>

        {/*Object.keys(enquiry).length > 0 && (<EnquiryDialog enquiry={enquiry} open={open} handleClose={this.handleClose} />)*/}
      </Wrapper>
    );
  }
}

EnquiriesTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps ({ enquiries }) {
  return {
    enquiries
  }
}

export default connect(mapStateToProps)(withStyles(styles)(EnquiriesTable))


// WEBPACK FOOTER //
// ./src/components/Enquiries/Enquiries.js